module.exports = "../images/fishing-lodge-2-18.jpg?v=3181c1d";